// @mui
import Step from '@mui/material/Step'
import Stepper from '@mui/material/Stepper'
import StepLabel from '@mui/material/StepLabel'

// ----------------------------------------------------------------------

const steps = ['Descrição', 'Vendedores', 'Cardápio']

interface EventStepperProps {
  activeStep: number
  onStepClick?: (step: number) => void
}

export default function EventStepper({ activeStep, onStepClick }: EventStepperProps) {
  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((label, index) => {
        const stepProps: { completed?: boolean } = {}
        const labelProps: {
          optional?: React.ReactNode
        } = {}

        return (
          <Step key={label} {...stepProps}>
            <StepLabel
              {...labelProps}
              onClick={() => onStepClick?.(index)}
              sx={{
                cursor: onStepClick ? 'pointer' : 'default',
                '.MuiStepLabel-iconContainer': {
                  cursor: onStepClick ? 'pointer' : 'default',
                },
                '&:hover': {
                  opacity: onStepClick ? 0.8 : 1,
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        )
      })}
    </Stepper>
  )
}
